module.exports = __webpack_public_path__ + "img/amunes_logo_site.95dbc97a.png";